import React from 'react';
import { DataGridButton, IColumnType, IDataType, SisDataGridColumns } from '../../components/table';

export const Columns = (handleEdit, translate): SisDataGridColumns => [
  {
    dataType: IDataType.number,
    dataField: 'id',
    width: '5%',
    caption: 'Step id',
  },
  {
    dataType: IDataType.string,
    dataField: 'name',
    width: '20%',
    caption: 'Name',
  },
  {
    dataField: 'capacityCategoryName',
    width: '15%',
    caption: 'Capacity category',
    lookupPickBy: 'capacityCategoryName',
  },
  {
    dataType: IDataType.string,
    dataField: 'description',
    width: '42%',
    caption: 'Description',
  },
  {
    dataField: 'visible',
    dataType: IDataType.boolean,
    caption: 'Visible',
    width: '10%',
  },
  {
    type: IColumnType.buttons,
    cellRender: (data) => ButtonCell(data, handleEdit, translate),
    width: '8%',
  },
];

const ButtonCell = (cellData, handleEdit, translate) => {
  return (
    <DataGridButton
      hint={translate!('Edit', '')}
      icon="edit"
      cellData={cellData}
      onClick={() => handleEdit(cellData)}
    />
  );
};
